// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".verbal-consent-script{margin-top:20px;margin-bottom:20px}.verbal-consent-script p{line-height:1.5em}.verbal-consent-script__heavy{font-weight:bold}.verbal-consent-script ul{margin-bottom:20px}.verbal-consent-script ul li{margin:16px 0;padding-left:6px}", ""]);
// Exports
module.exports = exports;
